import {
  DASHBOARD_GET_DATA,
  AUTH_LINK_GOOGLE,
  AUTH_UNLINK_GOOGLE,
  MESSAGELOG_DATA,
  MESSAGELOG_DATA_AGR_DEVICE,
  MESSAGELOG_DATA_AGR_CUSTOMER,
  MESSAGELOG_DATA_AGR_CUSTOMER_START,
  MESSAGELOG_DATA_AGR_DEVICE_DATA,
  MESSAGELOG_DATA_DETAILED_DATA_START,
  MESSAGELOG_DATA_SETLOADER,
} from "../actions/types";

const DEFAULT_STATE = {
  secret: "",
  methods: [],
  blobContents: "",
  messageLogDeviceData: [],
  messageLogCustomerData: [],
  messageDeviceData: [],
  isLoadingData: false,
};

export default (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case AUTH_LINK_GOOGLE:
      return { ...state, methods: action.payload.methods };
    case AUTH_UNLINK_GOOGLE:
      return { ...state, methods: action.payload.methods };
    case MESSAGELOG_DATA:
      return {
        ...state,
        messageDeviceData: state.messageDeviceData.map((deviceData) =>
          deviceData.MAddress === action.payload.device2
            ? {
                ...deviceData,
                showChild: true,
                messageLogData: action.payload.data,
              }
            : { ...deviceData, showChild: false }
        ),
        isLoadingData: false,
      };
    case MESSAGELOG_DATA_AGR_CUSTOMER_START:
      return {
        ...state,
        isLoadingData: action.payload,
        messageLogDeviceData: [],
        messageLogCustomerData: [],
        messageDeviceData: [],
      };
    case MESSAGELOG_DATA_DETAILED_DATA_START:
      return {
        ...state,
        isLoadingData: action.payload,
        messageLogDeviceData: [],
      };
    case MESSAGELOG_DATA_AGR_DEVICE:
      return {
        ...state,
        messageLogDeviceData: action.payload.data,
        isLoadingData: false,
      };
    case MESSAGELOG_DATA_AGR_CUSTOMER:
      return {
        ...state,
        messageLogCustomerData: action.payload,
        isLoadingData: false,
      };
    case MESSAGELOG_DATA_AGR_DEVICE_DATA:
      return {
        ...state,
        messageDeviceData: action.payload,
        isLoadingData: false,
      };
    case MESSAGELOG_DATA_SETLOADER:
      return {
        ...state,
        isLoadingData: action.payload,
      };
    case DASHBOARD_GET_DATA:
      return {
        ...state,
        secret: action.payload.secret,
        methods: action.payload.methods,
      };
    default:
      return state;
  }
};
